/**
 * Sistema de cards padrão para exibição de dados em grid de 12 colunas.
 *
 * Componentes:
 *  - GridCardRow: linha do grid (12 colunas por padrão, responsivo)
 *  - GridCard: card individual, com `cols` 1..12 para largura
 *  - GridCardSection: seção interna do card com label
 *  - GridCardField: par label/valor formatado por tipo
 *
 * Uso típico:
 *  <GridCardRow>
 *    <GridCard :cols="6" titulo="Tabela #1" accent>
 *      <template #meta>
 *        <span class="sistema-badge sistema-badge--ativo">Ativo</span>
 *      </template>
 *
 *      <GridCardSection label="Custo">
 *        <div class="campos-grid">
 *          <GridCardField label="CMV" :valor="12.50" tipo="monetary" />
 *          <GridCardField label="Preço Mín." :valor="15.00" tipo="monetary" destaque />
 *        </div>
 *      </GridCardSection>
 *    </GridCard>
 *  </GridCardRow>
 */
import GridCardRow from "./GridCardRow.vue";
import GridCard from "./GridCard.vue";
import GridCardSection from "./GridCardSection.vue";
import GridCardField from "./GridCardField.vue";

export { GridCardRow, GridCard, GridCardSection, GridCardField };

export default {
  install(Vue) {
    Vue.component("GridCardRow", GridCardRow);
    Vue.component("GridCard", GridCard);
    Vue.component("GridCardSection", GridCardSection);
    Vue.component("GridCardField", GridCardField);
  },
};
